import { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

import { ChartRendererProps } from '../../types/chart-renderer-props';
import { toApexAxisChartSeries, toApexCategories } from '../../utils/to-apex-series';
import { ChartContainer } from '../shared/chart-container.component';
import { useUnknownChartSeriesLabel } from '../shared/use-chart-series-display-name';
import { getBarChartOptions } from './bar-chart-options';

export const BarChart = ({ data, className, minHeight = 160, stacked = false, chartOptions }: ChartRendererProps) => {
    const unknownLabel = useUnknownChartSeriesLabel();
    const series = useMemo(() => toApexAxisChartSeries(data, unknownLabel), [data, unknownLabel]);
    const categories = useMemo(() => toApexCategories(data), [data]);

    return (
        <ChartContainer
            className={className}
            minHeight={minHeight}>
            {(size) => (
                <ReactApexChart
                    options={{
                        ...getBarChartOptions({
                            categories,
                            stacked,
                            showLegend: data.series.length > 1,
                            height: size.height,
                            width: size.width
                        }),
                        ...chartOptions
                    }}
                    series={series}
                    type='bar'
                    height={size.height}
                    width={size.width}
                />
            )}
        </ChartContainer>
    );
};
